import { Box, Stack } from '@chakra-ui/react';
import Button, { ButtonVariants } from '@components/interactive/Button';
import TextLink from '@components/interactive/TextLink';
import Body1 from '@components/typography/Body1';
import { Routes } from '@constants/routes';
import { useAuthenticatedContextProvider } from '@contexts/AuthenticatedContextProvider';
import { FontSizes } from 'chakra-ui/fsmTheme';

export const DashboardHelp = ({ handleLogout }) => {
  const { isBedrock } = useAuthenticatedContextProvider();

  return (
    <Stack mt={10} spacing={6}>
      {!isBedrock && (
        <>
          <Box>
            <Body1 display="inline">Questions? Email &nbsp;</Body1>
            <TextLink
              href="mailto:agents@fairsquaremedicare.com"
              text="agents@fairsquaremedicare.com."
              fontSize={[FontSizes.body1.mobile, FontSizes.body1.mobile, FontSizes.body1.desktop]}
            />
          </Box>
        </>
      )}
      <Box>
        <Button variant={ButtonVariants.secondary} onClick={handleLogout}>
          Log Out
        </Button>
      </Box>
    </Stack>
  );
};
